import { observer } from 'mobx-react-lite'
import { HandoffDialog } from '@/features/shell/handoff/HandoffDialog/index'
import { useFeatures } from '@/contexts/root-store-context'
import { useLightDarkFn } from '@/features/shell/theming/color-scheme-hooks'

/**
 * Handoff Dialog Container
 */
export const HandoffDialogContainer = observer(
  function HandoffDialogContainer() {
    const { internal } = useFeatures(({ shell }) => ({
      internal: shell.internal,
    }))
    const vm = internal.handoffVm
    const handoffInfo = vm.handoffInfo
    const lightDark = useLightDarkFn()
    if (!handoffInfo) {
      return null
    }
    return (
      <HandoffDialog
        isOpen={vm.modal.showing}
        partnerName={handoffInfo.name}
        partnerIconUrl={lightDark(
          handoffInfo.iconUrl,
          handoffInfo.invertedIconUrl,
        )}
        onGetStartedPress={vm.getStarted}
        onCancelPress={vm.backToPartner}
        isCancelAllowed={handoffInfo.isCancelAllowed}
      />
    )
  },
)
